import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { ADD_ROTATION_POSITION } from './actionTypes';
import { addRotationPositionSuccess, addRotationPositionError } from './actions';

// Include call API
import { getWorkstationsAPI } from '../../../api/workstations';

const workstationAPI = getWorkstationsAPI();

function* addRotationPosition({ payload: { ws_pos, rotation_point, token, history } }) {
  try {
    const response = yield call(workstationAPI.addRotationPosition, ws_pos, rotation_point, token);
    yield put(addRotationPositionSuccess(response.message, response.addedRotation));
    history.go();
  } catch (error) {
    yield put(addRotationPositionError(error));
  }
}

export function* watchAddRotationPosition() {
  yield takeEvery(ADD_ROTATION_POSITION, addRotationPosition);
}

function* AddRotationPositionSaga() {
  yield all([fork(watchAddRotationPosition)]);
}

export default AddRotationPositionSaga;
